<template>
    <div>
        <!-- Start Footer Area  -->
        <footer v-if="data.showFooter" class="rn-footer footer-style-default variation-two">
            <div v-if="data.showCta" class="rn-callto-action clltoaction-style-default style-7">
                <div class="container">
                    <div class="row row--0 align-items-center content-wrapper" style="border-bottom: none">
                        <div class="col-lg-12">
													<img src="@/assets/images/bwt/logo.jpg" alt="船水技术" style="height: 64px"/>
													<div class="copyright-style-one" style="border: none; padding: 0; display: inline-block; margin-left: 20px;">
														<ul class="ft-menu link-hover">
															<li>
																<a href="https://citadeldata.cn/" target="_blank" style="font-size: 16px">城堡数据</a>
															</li>
															<li>
																<a href="https://chercloud.cn/" target="_blank"  style="font-size: 16px">中炘云网</a>
															</li>
															<li>
																<a style="font-size: 16px">臻熙天成</a>
															</li>
															<li>
																<a href="https://chersafe.com/" target="_blank"  style="font-size: 16px">安炘嘉得</a>
															</li>
														</ul>
													</div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <Copyright v-if="data.showCopyright"/>

        <ScrollTop/>
    </div>
</template>

<script>
    import Copyright from './Copyright'
    import Button from '../../elements/button/Button'
    import Icon from '../../icon/Icon'
    import ScrollTop from './ScrollTop'
    import Logo from '../../elements/logo/Logo'
    import Newsletter from './Newsletter'

    export default {
        name: 'Footer',
        components: {Newsletter, Logo, ScrollTop, Icon, Button, Copyright},
        props: {
            data: {
                default: null
            }
        }
    }
</script>
